var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { ActionButtonWrapper, DeleteWrapper, ResetPasswordWrapper, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import Tooltip from 'rc-tooltip';
import Pagination from '../Pagination';
import Table from './Table';
import ResetPassword from '../../containers/AppUsers/ResetPassword';
var Index = function (_a) {
    var columns = _a.columns, height = _a.height, data = _a.data, selectedRows = _a.selectedRows, datasetType = _a.datasetType, handleClickCheckBox = _a.handleClickCheckBox, handleClickAllCheckBox = _a.handleClickAllCheckBox, setIsVisibleDeleteConfirmation = _a.setIsVisibleDeleteConfirmation, setIdToDelete = _a.setIdToDelete, goToEdit = _a.goToEdit, handlePasswordReset = _a.handlePasswordReset, searchValue = _a.searchValue, actionColumnWidth = _a.actionColumnWidth, _b = _a.showSelectRow, showSelectRow = _b === void 0 ? true : _b, _c = _a.showPagination, showPagination = _c === void 0 ? true : _c, handleClickRow = _a.handleClickRow, extraActionComponent = _a.extraActionComponent, paginationIndex = _a.paginationIndex, setPagination = _a.setPagination, template = _a.template, _d = _a.sharing, sharing = _d === void 0 ? false : _d, _e = _a.organizationId, organizationId = _e === void 0 ? '' : _e;
    var _f = useState(false), isPasswordResetVisible = _f[0], setIsPasswordResetVisible = _f[1];
    var selectedEmail = useRef('');
    var editComponent = function (item) {
        return (_jsx(ActionButtonWrapper, __assign({ onClick: function () {
                goToEdit && goToEdit(item.id);
            } }, { children: _jsx(FontAwesomeIcon, { color: "#828282", icon: faPen }) })));
    };
    var deleteComponent = function (item) {
        return (_jsx(DeleteWrapper, __assign({ onClick: function () {
                setIsVisibleDeleteConfirmation &&
                    setIsVisibleDeleteConfirmation(true);
                setIdToDelete && setIdToDelete(item.id);
            } }, { children: _jsx(FontAwesomeIcon, { color: "#828282", icon: faTrashAlt }) })));
    };
    var moreComponent = function (item) {
        return (_jsx(_Fragment, { children: _jsx(Tooltip, __assign({ zIndex: isPasswordResetVisible ? -1 : 1000, placement: "bottomRight", trigger: ['hover'], overlay: _jsxs(ResetPasswordWrapper, __assign({ onClick: function () {
                        selectedEmail.current = item.email;
                        setIsPasswordResetVisible(!isPasswordResetVisible);
                    } }, { children: [_jsx(FontAwesomeIcon, { color: "#828282", icon: faLock }), _jsx(_Fragment, { children: "Reset Password" })] })), showArrow: false, overlayInnerStyle: {
                    fontSize: 12,
                    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.15)',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    width: '142px',
                    height: '36px',
                }, overlayStyle: {
                    opacity: 1,
                    paddingTop: '0px',
                } }, { children: _jsx(ActionButtonWrapper, { children: _jsx(FontAwesomeIcon, { color: "#828282", icon: faEllipsisV }) }) })) }));
    };
    var actionButtonComponentsArray = [];
    !!extraActionComponent &&
        actionButtonComponentsArray.push(extraActionComponent);
    !!goToEdit && actionButtonComponentsArray.push(editComponent);
    !!setIdToDelete && actionButtonComponentsArray.push(deleteComponent);
    !!handlePasswordReset && actionButtonComponentsArray.push(moreComponent);
    var actionButtonComponents = actionButtonComponentsArray.length
        ? actionButtonComponentsArray
        : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(ResetPassword, { count: selectedRows ? selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length : 1, isVisible: isPasswordResetVisible, visibleConfirmation: setIsPasswordResetVisible, resetFunction: function () {
                    handlePasswordReset && handlePasswordReset(selectedEmail.current);
                    selectedEmail.current = '';
                } }), _jsx(Table, { height: height, columns: columns, data: data, searchValue: searchValue, actionButtonComponents: actionButtonComponents, actionColumnWidth: actionColumnWidth, selectedRows: selectedRows, handleClickCheckBox: handleClickCheckBox, datasetType: datasetType, handleClickAllCheckBox: handleClickAllCheckBox, showSelectRow: showSelectRow, showPagination: showPagination, paginationComponent: Pagination, handleClickRow: handleClickRow, paginationIndex: paginationIndex, setPagination: setPagination, template: template, sharing: sharing, organizationId: organizationId })] }));
};
export default Index;
